import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importEditPhoneContainer = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "EditPhoneContainer" */
                '@perpay-web/fintech/components/containers/EditPhoneContainer'
            ),
    );
